import { Injectable, isDevMode } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
  HTTP_INTERCEPTORS
} from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class AuthorizationInterceptor implements HttpInterceptor {

  constructor() {}

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    //return next.handle(request);
    const token_jwt = localStorage.getItem('token_jwt')
    const token = localStorage.getItem('token')
    const token_type = localStorage.getItem('token_type')
    if( token || token_jwt ){
      const cloned = request.clone({
        headers: request.headers.set('Authorization', token_jwt ? `Basic ${btoa(token_jwt)}` : `${token_type} ${token}`)
      })
      if( isDevMode() )console.log(`headers: ${JSON.stringify(cloned)}`)
      return next.handle(cloned)
    }
    return next.handle(request)

  }
}


export const AuthorizationProvider = {
  // use fake backend in place of Http service for backend-less development
  provide: HTTP_INTERCEPTORS,
  useClass: AuthorizationInterceptor,
  multi: true
};